<div class="row">
    <span style="margin: 20px"> {{ params.node.key }} </span>
    <button [disabled] = "!isEditable" *ngIf="params.node.field != 'Material' && params.node.field != 'MaterialDescription'" (click)="addData(params)" title="Edit" style="padding-right: 10px">
        <img src="/assets/icons/Plus.svg" height="20" width="20" alt="Add Icon" style="filter: invert(1);"/>
    </button>
</div>
